__turbopack_context__.v({
  "className": "GWyQzq_className",
  "variable": "GWyQzq_variable",
});
